import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "_flexcol _gap-1",
  role: "region",
  "aria-labelledby": "tags-list-title"
}
const _hoisted_2 = { class: "_flex _jc-sb _ai-c" }
const _hoisted_3 = { class: "_fw-b" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tag_box = _resolveComponent("tag-box")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", {
      id: "tags-list-title",
      class: "_sr-only"
    }, "Tags list", -1 /* CACHED */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createBlock(_component_tag_box, {
        key: item.url,
        url: item.url,
        "data-qa": item.qa
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1 /* TEXT */),
            _createVNode(_component_base_icon, {
              "is-fixed-width": "",
              name: item.icon,
              class: _normalizeClass(item.iconColor),
              size: "lg",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["name", "class"])
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["url", "data-qa"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}